import { z } from 'zod';
import type { TaxCategoryToken } from '@sleed/bizcommerce-api';
import { TaxType, TaxStatus } from '@sleed/bizcommerce-api';

/**
 * Tax category (Κατηγορία ΦΠΑ) edit form. Mirrors `TaxCategoryToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Pricing/TaxCategories/index.js): nm required ≤100, tt (tax type)
 * and ts (tax status) required enums, ci (country) optional, rt (rate) required, iv visible,
 * si required sort order. Tax type/status option labels come from the
 * gettaxtypes / gettaxstatus endpoints (EnumToken { id, nm }).
 */
export const taxCategorySchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	tt: z.nativeEnum(TaxType),
	ts: z.nativeEnum(TaxStatus),
	ci: z.number().nullable(),
	rt: z.number({ message: 'validation.required' }),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type TaxCategoryFormValues = z.infer<typeof taxCategorySchema>;

export const EMPTY_TAX_CATEGORY: TaxCategoryFormValues = {
	nm: '',
	tt: TaxType.Normal,
	ts: TaxStatus.Normal,
	ci: null,
	rt: 0,
	iv: true,
	si: 1
};

export function tokenToForm(token: TaxCategoryToken): TaxCategoryFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		tt: token.tt ?? TaxType.Normal,
		ts: token.ts ?? TaxStatus.Normal,
		ci: token.ci ?? null,
		rt: token.rt ?? 0,
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: TaxCategoryFormValues): TaxCategoryToken {
	return {
		id: form.id,
		nm: form.nm.trim(),
		tt: form.tt,
		ts: form.ts,
		ci: form.ci,
		rt: form.rt,
		iv: form.iv,
		si: form.si
	};
}
